import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoginService } from '@services/login.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class LogoutComponent implements OnInit {

  constructor(
    private readonly loginService: LoginService
  ) { }

  ngOnInit(): void {
    this.loginService.logout();
  }
}
